
export const areaDict: any = {
  hk: '香港',
  macau: '澳门',
};

export const languageDict: any = {
  en: 'EN',
  zh: '繁',
};

export const languageMenuItems: any = [
  {
    key: 'en',
    label: 'EN'
  },
  {
    key: 'zh',
    label: '繁'
  }
];


export const promotionBannerUrlMap: any = {
  '/blog': 'blog_homepage',
  '/blog/[category]': 'blog_category',
  '/blog/[category]/[article]': 'blog_article_pages',
  '/blog/search': 'blog_search_page',
  '/blog/author/[authorName]': 'blog_author_pages',
  //TODO: should confirm the value by CMS set up  2024
 '/blog/guide/introdution': 'blog_wiki_category',
  '/blog/guide/[article]': 'blog_wiki_article',
}

export const popupBannerUrlMap: any = {
  '/blog': '/blog',
  '/blog/[category]': '/blog/categories',
  '/blog/[category]/[article]': '/blog/articles',
  '/blog/search': '/blog/search&tags',
  '/blog/author/[authorName]': '/blog/authors',
  '/blog/guide/introdution': 'blog_wiki_category',
  '/blog/guide/[article]': 'blog_wiki_article',
}

export const mulPopupBannerUrlMap: any = {
  '/blog': '/blog',
  '/blog/[category]': '/blog/categories',
  '/blog/[category]/[article]': '/blog/articles',
  '/blog/search': '/blog/search&tags',
  '/blog/author/[authorName]': '/blog/authors',
  '/blog/guide/introdution': 'blog_wiki_category',
  '/blog/guide/[article]': 'blog_wiki_article',
}

export const mulPopupBannerContenttypeUidMap:any = {
  '/blog': 'blog_landing_page',
  '/blog/[category]': 'blog_category_landing_page',
  '/blog/[category]/[article]': 'blog_article_page',
  '/blog/search': 'blog_search',
  '/blog/author/[authorName]': 'blog_author',
  '/blog/guide/introdution': 'blog_wiki_category_page',
  '/blog/guide/[article]': 'blog_wiki_article_page',
}